/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Typography } from "@mui/material";
// import { useUpdateComponent } from 'cms/components/hooks/use-update-component'
import { useOrgSettings } from "hooks/use-org-settings";

const RoutewareCalendarComponentEditor = () => {

    const { getOrgSettingsString } = useOrgSettings();
    const rw_area = getOrgSettingsString("routeware_area");
    const name = "calendar";

    return (
        <div className='simplicity-editor-frame' style={{ minHeight: "300px" }} >
            <div style={{ width: "100%" }}>
                <Typography variant='overline' color={"text.secondary"}>
                    Area
                </Typography>
                <div className="routeware-config-display">
                    {rw_area}
                </div>
                <Typography variant='overline' color={"text.secondary"}>
                    Type
                </Typography>
                <div className="routeware-config-display">
                    {name}
                </div>
            </div>
            {/*<pre>GUID: {JSON.stringify(component,null,2)}</pre>*/}

        </div>
    );
};

RoutewareCalendarComponentEditor.displayName = "RoutewareCalendarComponentEditor";
export { RoutewareCalendarComponentEditor };
